import React from "react";
import {ValueValidator} from "../Validator";
import {OnValidChangeHandler, ValidationComponent, ValidationFieldName} from "./ValidationComponent";
import {RootState} from "../../../../app/store";
import {SelectDropdown, SelectOption} from "../../select/SelectDropdown";

interface Props<PROPERTY, OBJECT> {
    validator: ValueValidator<PROPERTY>
    selector: (state: RootState) => PROPERTY | undefined;
    fieldName: ValidationFieldName<OBJECT>;
    onChange: (value: PROPERTY) => any,
    updateValidationStatus: OnValidChangeHandler<OBJECT>,
    label: string;
    options: SelectOption<PROPERTY>[]
    getMessage: (f: string) => string
    labelAccessory?: React.ReactNode;
    required?: boolean
    disabled?: boolean
    selectFirstOptionByDefault?: boolean
    isClearable?: boolean
    placeholder?: string
}

export const ValidatedSelectField = <PROPERTY, OBJECT>({
                                                           validator,
                                                           selector,
                                                           fieldName,
                                                           onChange,
                                                           updateValidationStatus,
                                                           label,
                                                           options,
                                                           getMessage,
                                                           labelAccessory,
                                                           required = true,
                                                           disabled = false,
                                                           selectFirstOptionByDefault,
                                                           isClearable = false,
                                                           placeholder
                                                       }: Props<PROPERTY, OBJECT>) => {
    return <ValidationComponent<PROPERTY, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <SelectDropdown<PROPERTY>
                title={label}
                titleAccessory={labelAccessory}
                isRequired={required}
                value={value}
                disabled={disabled}
                handleChange={onChange}
                options={options}
                errorMessage={getMessage(fieldName as string)}
                selectFirstOptionByDefault={selectFirstOptionByDefault}
                isClearable={isClearable}
                placeholder={placeholder}
            />
        }
    />
}
